import Login from '@/views/Login.vue'
import store from '@/store'

const routeRoles = store.getters['auth/routeRoles']

const routes = [
  {
    path: '/',
    alias: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'WeClever - Login'
    }
  },
  {
    path: '/platform',
    name: 'platform',
    component: () => import('@/views/Platform.vue'),
    meta: {
      auth: true,
      title: 'WeClever - Plataformas'
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: {
      auth: true,
      title: 'WeClever - Dashboard'
    }
  },
  {
    path: '/leads',
    name: 'leads',
    component: () => import('@/views/Leads.vue'),
    meta: {
      auth: true,
      title: 'WeClever - Leads'
    }
  },
  {
    path: '/bv-fgts-lookup',
    name: 'bv-fgts-lookup',
    component: () => import('@/views/FgtsLookup.vue'),
    meta: {
      auth: true,
      title: 'WeClever - Consulta FGTS'
    }
  },
  {
    path: '/lead/:idLead',
    name: 'lead',
    component: () => import('@/views/Lead.vue'),
    meta: {
      auth: routeRoles('lead'),
      title: 'WeClever - Lead'
    }
  },
  {
    path: '/insight',
    name: 'insight',
    component: () => import('@/views/Insight.vue'),
    meta: {
      auth: routeRoles('insight'),
      title: 'WeClever - Insights'
    }
  },
  {
    path: '/my-account',
    name: 'my-account',
    component: () => import('@/views/MyAccount.vue'),
    meta: {
      auth: true,
      title: 'WeClever - Minha conta'
    }
  },
  {
    path: '/send-report',
    name: 'send-report',
    component: () => import('@/views/SendReport.vue'),
    meta: {
      auth: routeRoles('send-report'),
      title: 'WeClever - Enviar Relatório'
    }
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('@/views/Product.vue'),
    meta: {
      auth: routeRoles('product'),
      title: 'WeClever - Produtos'
    }
  },
  {
    path: '/squad',
    name: 'squad',
    component: () => import('@/views/Squad.vue'),
    meta: {
      auth: routeRoles('squad'),
      title: 'WeClever - Squad'
    }
  },
  {
    path: '/attribute',
    name: 'Atributos',
    component: () => import('@/views/Attribute.vue'),
    meta: {
      auth: routeRoles('attribute'),
      title: 'WeClever - Atributos'
    }
  },
  {
    path: '/management-commission',
    name: 'management-commission',
    component: () => import('@/views/ManagementCommission.vue'),
    meta: {
      auth: routeRoles('management-commission'),
      title: 'WeClever - Gerenciamento de Comissões'
    }
  },
  {
    path: '/management-hero',
    name: 'management-hero',
    component: () => import('@/views/ManagementHero.vue'),
    meta: {
      auth: routeRoles('management-hero'),
      title: 'WeClever - Gerenciamento da Métrica Heros'
    }
  },
  {
    path: '/lead-tabulation',
    name: 'lead-tabulation',
    component: () => import('@/views/LeadTabulation.vue'),
    meta: {
      auth: routeRoles('lead-tabulation'),
      title: 'WeClever - Tabulações'
    }
  },
  {
    path: '/commission',
    name: 'commission',
    component: () => import('@/views/Commission.vue'),
    meta: {
      auth: routeRoles('commission'),
      title: 'WeClever - Comissão'
    }
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/User.vue'),
    meta: {
      auth: routeRoles('user'),
      title: 'WeClever - Usuário'
    }
  },
  {
    path: '/ranking',
    name: 'ranking',
    component: () => import('@/views/Ranking.vue'),
    meta: {
      auth: routeRoles('ranking'),
      title: 'WeClever - Ranking'
    }
  },
  {
    path: '/conquest',
    name: 'conquest',
    component: () => import('@/views/Conquest.vue'),
    meta: {
      auth: routeRoles('conquest'),
      title: 'WeClever - Conquista'
    }
  },
  {
    path: '/repurchase',
    name: 'repurchase',
    component: () => import('@/views/Repurchase.vue'),
    meta: {
      auth: routeRoles('repurchase'),
      title: 'WeClever - Recompra'
    }
  },
  {
    path: '/cost-report',
    name: 'cost-report',
    component: () => import('@/views/CostReport.vue'),
    meta: {
      auth: routeRoles('cost-report'),
      title: 'WeClever - Relatório de Custo'
    }
  },
  // {
  //   path: '/app-message',
  //   name: 'app-message',
  //   component: () => import('@/views/AppMessage.vue'),
  //   meta: {
  //     auth: routeRoles('app-message'),
  //     title: 'WeClever - Mensagens Template'
  //   }
  // },
  // {
  //   path: '/follow-up',
  //   name: 'follow-up',
  //   component: () => import('@/views/FollowUp.vue'),
  //   meta: {
  //     auth: true,
  //     title: 'WeClever - Follow-up'
  //   }
  // },
  {
    path: '/app-chat',
    name: 'app-chat',
    component: () => import('@/views/AppChat.vue'),
    meta: {
      auth: routeRoles('app-chat'),
      title: 'WeClever - Conversas'
    }
  },
  {
    path: '/coupon',
    name: 'coupon',
    component: () => import('@/views/Coupon.vue'),
    meta: {
      auth: routeRoles('coupon'),
      title: 'WeClever - Cupom'
    }
  },
  {
    path: '/leads-upload',
    name: 'leads-upload',
    component: () => import('@/views/LeadsUpload.vue'),
    meta: {
      auth: routeRoles('leads-upload'),
      title: 'WeClever - Enviar Leads'
    }
  },
  {
    path: '/custom-indicators',
    name: 'custom-indicators',
    component: () => import('@/views/CustomIndicators.vue'),
    meta: {
      auth: routeRoles('custom-indicators'),
      title: 'WeClever - Dados personalizados'
    }
  },
  {
    path: '/leads-journey',
    name: 'leads-journey',
    component: () => import('@/views/LeadsJourney.vue'),
    meta: {
      auth: routeRoles('leads-journey'),
      title: 'WeClever - Jornada dos leads'
    }
  },
  {
    path: '/insight-conversations',
    name: 'insight-conversations',
    component: () => import('@/views/InsightConversations.vue'),
    meta: {
      auth: routeRoles('insight-conversations'),
      title: 'WeClever - Dados das conversas'
    }
  },
  {
    path: '/operational-performance',
    name: 'operational-performance',
    component: () => import('@/views/OperationalPerformance.vue'),
    meta: {
      auth: routeRoles('operational-performance'),
      title: 'WeClever - Performance Operacional'
    }
  },
  {
    path: '/leads-insight',
    name: 'leads-insight',
    component: () => import('@/views/LeadsInsight.vue'),
    meta: {
      auth: routeRoles('leads-insight--DISABLED'),
      title: 'WeClever - Insight dos leads'
    }
  },
  {
    path: '/insight-business',
    name: 'insight-business',
    component: () => import('@/views/InsightDemographics.vue'),
    meta: {
      auth: routeRoles('insight-business'),
      title: 'WeClever - Insight de negócios'
    }
  }
]

export default routes
